import { useDispatch } from "react-redux";
import { onChangeTATItem } from "../../../../../features/ebam/plicy-data-page/policy-tat/policy-tat.slice";
import { TATItems } from "../../../../../features/ebam/plicy-data-page/policy-tat/policy-tat.interface";
import { columnWidths } from "./policy-turn-around-time";

interface Props {
    items: TATItems[];
    isEditingTAT: boolean;
    // onChange: ( id: number, field: "tat" | "reckoning_date" | "mode_of_communication", value: string ) => void;
    colSpan: number;
    title: string;
}

export default function PolicyTATRows({ items, isEditingTAT, colSpan, title }: Props) {

    const dispatch = useDispatch()
    const inputStyle = `h-10 w-full rounded border px-3 text-xs outline-none transition ${
        isEditingTAT ? 'border-gray-300 bg-white focus:border-[#186cb2]' : 'cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500'
    }`
    if (!items.length) {
        return null;
    }

    return (
        <>
            <tr>
                <td className={`${columnWidths[0]} sticky left-0 z-10 border-b border-gray-200 bg-[#f7f79e] p-2 text-xs font-bold uppercase text-gray-700 after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-gray-200`}>
                    {title}
                </td>
                <td className={`${columnWidths[1]} border-b bg-[#f7f79e] border-gray-200 p-2`}></td>
                <td className={`${columnWidths[2]} border-b bg-[#f7f79e] border-gray-200 p-2`}></td>
                <td className={`${columnWidths[3]} border-b bg-[#f7f79e] border-gray-200 p-2`}></td>
                <td className={`${columnWidths[4]} border-b bg-[#f7f79e] border-gray-200 p-2`}></td>
                <td className={`${columnWidths[5]} border-b bg-[#f7f79e] border-gray-200 p-2`}></td>
            </tr>
            {items.map((item) => {
                const id = item.tat_id ?? item.sort_order;
                return (
                    <tr key={item.tat_id ?? item.sort_order}>
                        <td className={`${columnWidths[0]} sticky left-0 z-10 border-b border-gray-200 bg-white px-3 py-3 text-xs text-gray-700 after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-gray-200`}>
                            {item.activity}
                        </td>
                        <td className={`${columnWidths[1]} text-center px-4 py-3 border-gray-200 border-b border-r text-xs ${isEditingTAT ? '' : 'bg-gray-50 text-gray-500'}`}>
                            {isEditingTAT ? (
                                <input
                                    type="text"
                                    defaultValue={item.tat}
                                    disabled={!isEditingTAT}
                                    onChange={(e) => dispatch(onChangeTATItem({ id, field: "tat", value: e.target.value, }))}
                                    className={inputStyle}
                                />
                            ) : (
                                item.tat
                            )}
                        </td>
                        <td className={`${columnWidths[2]} text-center px-4 py-3 border-gray-200 border-b border-r text-xs ${isEditingTAT ? '' : 'bg-gray-50 text-gray-500'}`}>
                            {isEditingTAT ? (
                                <input
                                    type="text"
                                    defaultValue={item.reckoning_date}
                                    disabled={!isEditingTAT}
                                    onChange={(e) => dispatch(onChangeTATItem({ id, field: "reckoning_date", value: e.target.value, }))}
                                    className={inputStyle}
                                />
                            ) : (
                                item.reckoning_date
                            )}
                        </td>
                        <td className={`${columnWidths[3]} text-center px-4 py-3 border-gray-200 border-b border-r text-xs ${isEditingTAT ? '' : 'bg-gray-50 text-gray-500'}`}>
                            {isEditingTAT ? (
                                <input
                                    type="text"
                                    defaultValue={item.mode_of_communication}
                                    disabled={!isEditingTAT}
                                    onChange={(e) => dispatch(onChangeTATItem({ id, field: "mode_of_communication", value: e.target.value, }))}
                                    className={inputStyle}
                                />
                            ) : (
                                item.mode_of_communication
                            )}
                        </td>
                        <td className={`${columnWidths[4]} border-b border-r border-gray-200 bg-gray-50 text-center px-4 py-3 text-xs text-gray-500`}>
                            {item.responsible}
                        </td>
                        <td className={`${columnWidths[5]} border-b border-r border-gray-200 bg-gray-50 text-center px-4 py-3 text-xs text-gray-500`}>
                            {item.contact_details}
                        </td>
                    </tr>
                )
            })}
        </>
    );
}

